import React from 'react';
import Icon from '../../../components/AppIcon';

const AchievementHighlights = ({ child, detailed = false }) => {
  const mockAchievements = [
    {
      id: 1,
      title: 'Explorateur Assidu',
      description: 'A complété 10 quiz d\'orientation',
      icon: 'Compass',
      color: 'blue',
      unlockedDate: '2026-02-05',
      points: 100
    },
    {
      id: 2,
      title: 'Scientifique en Herbe',
      description: 'Excellence en matières scientifiques',
      icon: 'Atom',
      color: 'green',
      unlockedDate: '2026-02-08',
      points: 150
    },
    {
      id: 3,
      title: 'Communicateur',
      description: 'Participation active aux discussions',
      icon: 'MessageCircle',
      color: 'purple',
      unlockedDate: '2026-02-10',
      points: 75
    }
  ];

  const mockMilestones = [
    {
      id: 1,
      title: 'Premier Quiz Complété',
      date: '2026-01-15',
      icon: 'CheckCircle'
    },
    {
      id: 2,
      title: 'Première Recommandation Reçue',
      date: '2026-01-20',
      icon: 'Lightbulb'
    },
    {
      id: 3,
      title: 'Profil Complété à 100%',
      date: '2026-01-25',
      icon: 'Award'
    }
  ];

  const colorClasses = {
    blue: 'from-blue-400 to-blue-600',
    green: 'from-green-400 to-green-600',
    purple: 'from-purple-400 to-purple-600',
    amber: 'from-amber-400 to-amber-600'
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-card rounded-xl p-6 border border-border shadow-sm">
      <div className="flex items-center gap-3 mb-6">
        <Icon name="Award" size={24} className="text-primary" />
        <h2 className="text-xl font-semibold text-foreground">
          Réalisations et Jalons
        </h2>
      </div>

      {/* Achievements */}
      <div className="mb-6">
        <h3 className="text-base font-semibold text-gray-900 mb-4">Badges Débloqués</h3>
        <div className="grid grid-cols-1 gap-4">
          {mockAchievements?.map((achievement) => (
            <div
              key={achievement?.id}
              className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg p-4 border border-gray-200"
            >
              <div className="flex items-start gap-4">
                <div
                  className={`flex-shrink-0 w-14 h-14 bg-gradient-to-br ${colorClasses?.[achievement?.color]} rounded-full flex items-center justify-center shadow-lg`}
                >
                  <Icon name={achievement?.icon} size={28} color="#FFFFFF" />
                </div>
                <div className="flex-1">
                  <h4 className="text-base font-bold text-gray-900 mb-1">
                    {achievement?.title}
                  </h4>
                  <p className="text-sm text-gray-600 mb-2">{achievement?.description}</p>
                  <div className="flex items-center gap-4 text-xs text-gray-500">
                    <div className="flex items-center gap-1">
                      <Icon name="Calendar" size={14} />
                      <span>{formatDate(achievement?.unlockedDate)}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="Zap" size={14} className="text-amber-500" />
                      <span className="font-semibold text-amber-600">+{achievement?.points} pts</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Milestones */}
      {detailed && (
        <div>
          <h3 className="text-base font-semibold text-gray-900 mb-4">Jalons Importants</h3>
          <div className="space-y-3">
            {mockMilestones?.map((milestone, index) => (
              <div key={milestone?.id} className="flex items-start gap-3">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                    <Icon name={milestone?.icon} size={20} className="text-blue-600" />
                  </div>
                </div>
                <div className="flex-1">
                  <p className="text-sm font-semibold text-gray-900">{milestone?.title}</p>
                  <p className="text-xs text-gray-500">{formatDate(milestone?.date)}</p>
                </div>
                {index < mockMilestones?.length - 1 && (
                  <div className="absolute left-5 top-10 w-0.5 h-8 bg-gray-200" />
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Summary */}
      <div className="mt-6 pt-6 border-t border-gray-200">
        <div className="bg-gradient-to-r from-amber-50 to-amber-100 rounded-lg p-4 border border-amber-200">
          <div className="flex items-center gap-3">
            <Icon name="Trophy" size={24} className="text-amber-600" />
            <div>
              <p className="text-sm font-semibold text-amber-900">
                Total des Points d'Exploration
              </p>
              <p className="text-2xl font-bold text-amber-600">
                {mockAchievements?.reduce((sum, a) => sum + a?.points, 0)} points
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AchievementHighlights;